<template>
    <div class="modal bookable-slot" :class="{'d-none': !showSurvey }" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="card border-0">
                    <div class="card-body pb-sm-5 pb-5">
                        <div class="row">
                            <div class="col-10 offset-1">
                                <div class="row mb-4 mt-4 mt-sm-5">
                                    <div class="col-12">
                                        <h2 class="text-2xl fw-bold" v-html="$t('Spørreundersøkelse')"></h2>
                                        <p class="text-sm text-elev-blue-dim" v-html="description"></p>
                                    </div>
                                </div>

                                <div v-for="question in questions" :key="question.id">
                                    <Question :questionId="question.id"></Question>
                                </div>

                                <!-- Buttons -->
                                <div class="row mb-3">
                                    <div class="col-12 text-center" v-if="!success.length">
                                        <button class="btn btn-elev-blue btn-block py-3 fw-bold" @click.prevent="submit" :disabled="!canSubmit">
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="isSubmitting"></span>
                                            Send
                                        </button>
                                    </div>
                                    <div class="col-12 text-center" v-if="success.length">
                                        <div class="alert alert-success rounded">
                                            {{ success }}
                                        </div>
                                    </div>

                                </div>
                                <div>
                                    <a href="#" class="text-elev-blue-dim text-decoration-none btn-block btn btn-link font-weight-bolder" @click.prevent="close">{{ $t('Lukk') }}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue'
import Question from './Question'
import SurveyStore from '../../state/surveyStore.js'

const state = SurveyStore.state

const description = computed(() => SurveyStore.description())
const showSurvey = computed(() => SurveyStore.show())
const isSubmitting = computed(() => state.submitting)
const questions = computed(() => SurveyStore.getQuestions())
const canSubmit = computed(() => SurveyStore.canSubmit())
const success = computed(() => state.success)

const submit = () => {
    SurveyStore.submit()
}

const close = () => {
    SurveyStore.close()
}
</script>